import React from "react";
import {graphql} from "react-apollo";
import {flowRight as compose} from "lodash";
import {Field, FieldArray, reduxForm} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS, List} from "immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";
import {cancelReceivePurchaseOrder, successReceivePurchaseOrder} from "../../../actions/PurchaseOrderApiActions";
import {GET_PURCHASE_ORDER} from "../../../queries/purchaseOrders";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";

function numerical(value) {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? value : parsed;
}

const ReceivedLines = ({fields, lines}) => fields.map((member, index) => {
  const line = lines[index];
  return (
    <React.Fragment key={index}>
      <tr className="lineSeparator">
        <th>{line.sku}</th>
        <td>{line.productTitle} · Ordered {line.quantity}</td>
      </tr>
      <Field label="Received" name={`${member}.quantity`} type="number" normalize={numerical} component={TextInputField} />
    </React.Fragment>
  )
});

const ReceiveForm = reduxForm({form: "ReceivePurchaseOrderForm"})((props) => {
  const label = props.submitting ? "Standby..." : "Receive";
  return (
    <form onSubmit={props.handleSubmit}>
      <div className="fields">
        <p>Enter what actually arrived for each line (it starts at the quantity ordered). The received quantities are added to the warehouse's stock. This happens once: a purchase order is received in one go.</p>
        <FormFieldsTable>
          <FieldArray name="received" component={ReceivedLines} props={{lines: props.lines}} />
        </FormFieldsTable>
      </div>
      <FormError error={props.errors._error} />
      <div className="buttons">
        <ActionButton label={label} onClick={props.submit} active={!props.submitting} />
        <ActionButton label="Cancel" active={!props.submitting} onClick={props.onCancel} />
      </div>
    </form>
  )
});

class ReceivePurchaseOrderFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const lines = values.get("received", List()).map((line) => ({sku: line.get("sku"), quantity: parseInt(line.get("quantity"), 10) || 0})).toJS();
    return this.props.receivePurchaseOrder({purchaseOrderId: this.props.purchaseOrderId, lines})
      .then((response) => {
        const errors = response.data.receivePurchaseOrder.errors;
        if (errors.length <= 0) this.props.successReceivePurchaseOrder();
        else this.setState({errors: createValidationErrors(errors, errors.map((error) => error.message).join("\n"))});
      })
      .catch((err) => this.setState({errors: createErrors(err)}));
  }

  render() {
    const {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const lines = data.purchaseOrder.lines || [];

    return (
      <ReceiveForm
        initialValues={fromJS({received: lines.map(({sku, quantity}) => ({sku, quantity}))})}
        lines={lines}
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={() => this.props.cancelReceivePurchaseOrder()}
        />
    )
  }
}

const RECEIVE_PURCHASE_ORDER = gql`
  mutation receivePurchaseOrder($data: ReceivePurchaseOrderInput!) {
    receivePurchaseOrder(input: $data) {
      errors { key message }
    }
  }
`;

const withData = compose(
  graphql(GET_PURCHASE_ORDER, {options: (props) => ({fetchPolicy: "network-only", variables: {id: props.purchaseOrderId}})}),
  graphql(RECEIVE_PURCHASE_ORDER, {props: ({mutate}) => ({receivePurchaseOrder: (data) => mutate({variables: {data}})})}),
);

export default connect(null, {cancelReceivePurchaseOrder, successReceivePurchaseOrder})(withData(ReceivePurchaseOrderFormContainer));
